import { createAction } from "@ngrx/store";

import { RgInteractionsRealTimePaylod } from "./rg-interactions.model";

const ACTION_PREFIX = "[Rg Interactions]";

export namespace RgInteractionsAction {
	export const verifyInteraction = createAction(
		`${ACTION_PREFIX} Verify Interaction`,
		(alert: RgInteractionsRealTimePaylod) => ({ alert })
	);

	export const addPopupToQueue = createAction(
		`${ACTION_PREFIX} Add Popup to Queue`,
		(alert: RgInteractionsRealTimePaylod) => ({ alert })
	);

	export const closePopup = createAction(`${ACTION_PREFIX} Close Popup`, (alert: RgInteractionsRealTimePaylod) => ({
		alert,
	}));
}
